import { compose } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

let composeEnchancersWithDevToolInDevMode = compose;

if (process.env.NODE_ENV !== "production") {
    composeEnchancersWithDevToolInDevMode = composeWithDevTools({});
}

export const composeEnchancers = composeEnchancersWithDevToolInDevMode;
